module.exports = __webpack_public_path__ + "3c17b875d01961b26f2547cd1277bf04.svg";